
import { defineComponent } from 'vue'
export default defineComponent({
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    width: {
      type: String,
      default: 'inherit'
    },
    image: {
      type: String,
      required: false,
      default: ''
    }
  }
})
